import { render } from "./RegisterBox.vue?vue&type=template&id=6053100c&scoped=true"
import script from "./RegisterBox.vue?vue&type=script&lang=js"
export * from "./RegisterBox.vue?vue&type=script&lang=js"

import "./RegisterBox.vue?vue&type=style&index=0&id=6053100c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6053100c"]])

export default __exports__